import { DailyCount } from '@/types/observability';

import { formatChartDate } from './analyticsUtils';

export function InvocationsTrendChart( { data }: { data: DailyCount[] } ) {
  if ( data.length < 1 ) return null;

  const W = 500, H = 180;
  const m = { t: 20, r: 20, b: 35, l: 45 };
  const iW = W - m.l - m.r;
  const iH = H - m.t - m.b;

  const maxVal = Math.max( ...data.map( d => d.count ), 1 );
  const xAt = ( i: number ) => ( data.length === 1 ? m.l + iW / 2 : m.l + ( i / ( data.length - 1 ) ) * iW );
  const yAt = ( v: number ) => m.t + iH - ( v / maxVal ) * iH;

  const pts = data.map( ( d, i ) => `${ xAt( i ) },${ yAt( d.count ) }` ).join( ' ' );
  const yTicks = [ 0, 0.25, 0.5, 0.75, 1 ].map( r => Math.round( r * maxVal ) );
  const labelEvery = data.length <= 10 ? 1 : 4;

  return (
    <svg viewBox={ `0 0 ${ W } ${ H }` } style={ { width: '100%', height: 'auto', display: 'block' } }>
      {yTicks.map( t => (
        <g key={ t }>
          <line x1={ m.l } y1={ yAt( t ) } x2={ W - m.r } y2={ yAt( t ) } stroke="#e5e7eb" strokeWidth={ 1 } />
          <text x={ m.l - 4 } y={ yAt( t ) } textAnchor="end" dominantBaseline="middle" fontSize={ 10 } fill="#9ca3af">{ t }</text>
        </g>
      ) )}
      {data.map( ( d, i ) => {
        if ( i % labelEvery !== 0 ) return null;
        return (
          <text key={ d.date } x={ xAt( i ) } y={ H - 5 } textAnchor="middle" fontSize={ 10 } fill="#9ca3af">
            { formatChartDate( d.date ) }
          </text>
        );
      } )}
      { data.length > 1 && <polyline points={ pts } fill="none" stroke="#2563eb" strokeWidth={ 2 } strokeLinejoin="round" strokeLinecap="round" /> }
      {data.map( ( d, i ) => (
        <circle key={ d.date } cx={ xAt( i ) } cy={ yAt( d.count ) } r={ 3 } fill="#2563eb" />
      ) )}
    </svg>
  );
}
